import type { ConfigRouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, type CommonCursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { ProgramUsersDataObject } from 'models/service';

type ProgramsUsersRequest = { sort?: string } & CommonCursorPaginationRailsParams;

export const getProgramsUsers = async ({
  config,
  routeParams: { id },
}: ConfigRouteParamsRequest<ProgramsUsersRequest, { id: string }>) =>
  apiClient.get<ProgramUsersDataObject, ApiClientResponse<ProgramUsersDataObject>>(routes.program.users(id), config);
